// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rm","category":"rn","tab":"ro","selected":"rp","isRental":"rq"};